import React from 'react';

const Feature = () => {
  return (
    <>
      <div className="max-w-6xl mx-auto text-center mb-12 md:px-16">
        {/* Header */}
        <h3 className="text-md uppercase tracking-widest text-gray-500 mb-2">
          FLEXIBLE FUNDING
        </h3>
        <h2 className="text-4xl font-bold">
          Helping businesses grow on their terms
        </h2>
      </div>
    <div className="flex flex-col md:flex-row items-center justify-between gap-10 p-8 bg-white">
      {/* Left Section */}
      <div className="flex-1" data-aos="fade-up">
        <h1 className="text-2xl md:text-3xl font-bold mb-4">
          Smarter management for your business
        </h1>
        <p className="text-gray-600 mb-6">
          Our innovative solutions provide a clear direction, helping you
          streamline workflows, organize tasks effortlessly, & achieve
          unparalleled efficiency. Let Zenify Navigator be your compass on the
          journey to intelligent & effective business management.
        </p>
        <ul className="space-y-2 mb-6">
          <li className="flex items-center">
            <span className="w-4 h-4 bg-green-500 rounded-full inline-block mr-2"></span>
            Intuitive Task Organization
          </li>
          <li className="flex items-center">
            <span className="w-4 h-4 bg-green-500 rounded-full inline-block mr-2"></span>
            Customizable Dashboards
          </li>
          <li className="flex items-center">
            <span className="w-4 h-4 bg-green-500 rounded-full inline-block mr-2"></span>
            User Training and Support
          </li>
        </ul>
        <button className="px-6 py-2 border border-black rounded-full hover:bg-black hover:text-white transition">
          Explore More →
        </button>
      </div>

      {/* Right Section */}
      <div className="flex-1" data-aos="fade-down">
        <img
          src="/assests/images/LandingPage/feature/img1.png"
          alt="Team discussion"
          className="rounded-md shadow-md"
        />
      </div>
    </div>
    <div className="flex flex-col md:flex-row items-center justify-between gap-10 p-8 bg-white">
        {/* Right Section */}
        <div className="flex-1" data-aos="fade-up">
        <img
          src="/assests/images/LandingPage/feature/img1.png"
          alt="Team discussion"
          className="rounded-md shadow-md"
        />
      </div>
      {/* Left Section */}

      <div className="flex-1" data-aos="fade-down">
        <h1 className="text-2xl md:text-3xl font-bold mb-4">
          Smarter management for your business
        </h1>
        <p className="text-gray-600 mb-6">
          Our innovative solutions provide a clear direction, helping you
          streamline workflows, organize tasks effortlessly, & achieve
          unparalleled efficiency. Let Zenify Navigator be your compass on the
          journey to intelligent & effective business management.
        </p>
        <ul className="space-y-2 mb-6">
          <li className="flex items-center">
            <span className="w-4 h-4 bg-green-500 rounded-full inline-block mr-2"></span>
            Intuitive Task Organization
          </li>
          <li className="flex items-center">
            <span className="w-4 h-4 bg-green-500 rounded-full inline-block mr-2"></span>
            Customizable Dashboards
          </li>
          <li className="flex items-center">
            <span className="w-4 h-4 bg-green-500 rounded-full inline-block mr-2"></span>
            User Training and Support
          </li>
        </ul>
        <button className="px-6 py-2 border border-black rounded-full hover:bg-black hover:text-white transition">
          Explore More →
        </button>
      </div>

    
    </div>
  
    </>
  );
};

export default Feature;
